<template>
  <simple-page header="角色管理" @query="query">
    <template #buttons>
      <btn-add @click="edit"></btn-add>
    </template>

    <template #form>
      <el-form ref="queryForm" :model="queryForm" inline label-width="100px">
        <el-form-item label="角色名称">
          <el-input type="text" v-model="queryForm.roleName" maxlength="50"
                    placeholder="请输入角色名称模糊查询" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="queryForm.valid" clearable @change="query">
            <el-option value="1" label="是"></el-option>
            <el-option value="0" label="否"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </template>

    <el-table :data="records" :border="true" v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="roleCode" label="角色编码" align="center"></el-table-column>
      <el-table-column prop="roleName" label="角色名称" align="center"></el-table-column>
<!--      <el-table-column prop="roleType" label="角色类型" align="center">
        <template v-slot="{ row, $index }">
          <span v-if="row.sysRole" class="color-gray">系统角色</span>
          <span v-else>用户角色</span>
        </template>
      </el-table-column>
      <el-table-column prop="valid" label="状态" align="center" width="70">
        <template v-slot="{ row, $index }">
          <i class="fa fa-check-circle color-success" v-if="row.valid"></i>
          <i class="fa fa-times-circle color-error" v-else></i>
        </template>
      </el-table-column>-->
      <el-table-column prop="op" label="操作" width="150" align="center">
        <template v-slot="{ row, $index }">
          <el-button type="primary" size="small" @click="edit(row)" v-if="!row.sysRole">
            编辑
          </el-button>
          <el-button type="primary" size="small" @click="right(row)">
            授权
          </el-button>
          <el-button type="danger" size="small" @click="del(row)" v-if="!row.sysRole">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :visible.sync="settingRight"
               :show-close="false"
               direction="rtl">
      <template #title>
        <div class="right-title">
          <span class="title">角色授权可访问的菜单</span>
          <btn-save @click="saveRight" size="small"></btn-save>
        </div>
      </template>
      <role-menu-tree ref="roleMenuTree"
                      :role-id="currentRoleId"
                      v-if="currentRoleId"></role-menu-tree>
    </el-drawer>
  </simple-page>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import CodeSelect from "@/components/base/CodeSelect";
import SessionStore from "@/utils/SessionStore";
import SimplePage from "@/components/page/SimplePage.vue";
import BtnAdd from "@/components/btns/BtnAdd.vue";
import RoleMenuTree from "@/components/RoleMenuTree.vue";
import BtnSave from "@/components/btns/BtnSave.vue";

export default {
  components: {BtnSave, RoleMenuTree, BtnAdd, SimplePage, CodeSelect, TitleBar},
  extends: BaseVue,
  data() {
    return {
      settingRight: false,
      currentRoleId: null,
      records: [],
      queryForm: {
      }
    }
  },
  created() {
    this.query();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.postForm("/role/getRoles", this.queryForm, true).then((dr) => {
        this.records = dr.rows || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    query() {
      this.loadData();
    },
    //修改
    edit(row) {
      this.$router.push({
        path: "/roleEdit",
        query: row
      });
    },
    //删除
    del(row) {
      this.$confirm("确定要删除选中角色吗？","系统提示", {type:"warning"}).then(() => {
        this.loading = true;
        this.postForm("/role/delete", {
          roleId: row.roleId
        }, true).then((dr) => {
          this.loadData();
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    //授权
    right(row) {
      this.currentRoleId = row.roleId;
      this.settingRight = true;
    },
    //保存授权
    saveRight(row) {
      this.$refs["roleMenuTree"].save();
    }
  }
}
</script>

<style scoped lang="scss">
.right-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  span.title {
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
